import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Container,
  Row,
  Col,
  Input,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import ReactModal from "react-modal";
import Swal from "sweetalert2";

const ActualizaRepresentante = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState("");

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  useEffect(() => {
    const obtenerUsuarios = async () => {
      try {
        const response = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/AprobadoresLegal`,
        );
        setUsuarios(response.data);
      } catch (error) {
        console.error("Error al obtener los usuarios:", error);
      }
    };

    obtenerUsuarios();
  }, []);

  const enviarDatos = async () => {
    if (!selectedUsuario) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Debe seleccionar un usuario",
        willOpen: zIndexFix,
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.put(
        `https://contratosback.azurewebsites.net/api/v1/ActualizaSolicitud/${props.id}/0`,
        {
          representanteFirma: selectedUsuario,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      await Swal.fire({
        icon: "success",
        title: "Datos enviados",
        text: response.data,
        timer: 5500,
        showConfirmButton: false,
        willOpen: zIndexFix,
      });

      window.location.reload();
    } catch (error) {
      console.error("Error al enviar los datos:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data ||
          error.message ||
          "No se pudieron enviar los datos.",
        willOpen: zIndexFix,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-lg"
        onClick={() => setIsOpen(true)}
        title="Actualizar Representante"
        style={{
          padding: "5px 5px",
          fontSize: "10px",
          border: "2px solid grey",
        }}
      >
        Actualiza Representante
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Actualizar Representante"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={() => setIsOpen(false)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>

        <Header />

        <Container className="mt--7" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardHeader className="border-0 text-center">
                  Actualizar Representante Legal
                  <hr />
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <label htmlFor="usuarioSelect">Seleccione un usuario</label>
                    <Input
                      type="select"
                      id="usuarioSelect"
                      value={selectedUsuario}
                      onChange={(e) => setSelectedUsuario(e.target.value)}
                    >
                      <option value="">Seleccione</option>
                      {usuarios.map((usuario) => (
                        <option key={usuario.id} value={usuario.idUsuario}>
                          {usuario.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <button
                    className="btn btn-primary btn-user btn-block"
                    onClick={enviarDatos}
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" /> : "Confirmar"}
                  </button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default ActualizaRepresentante;
